
	import { defineComponent, PropType } from 'vue';

    import ReportExporter from '@/ChildrenComponents/ReportExporter.vue'

	import { IFiscalYearReport } from '@/Models/Report/IPhaseReport';
	import { IDataTableHeader } from '@/Models/IDataTableHeader';

	export default defineComponent({
		name: 'fiscal-year-report',
		components: { ReportExporter },
		props: {
			title: { type: String, required: true },
			filename: { type: String, required: true },
			isSearching: { type: Boolean, required: true },
			reportData: { type: Object as PropType<IFiscalYearReport[]>, required: true },
			headers: { type: Object as PropType<IDataTableHeader[]>, required: true },
			totalColumnTitle: { type: String, required: false, default: "Total" },
		},
		data () {
			return {
				fiscalHeaders: [
                    { title: "Jul", key: "jul", sortable: true, align: "start", width: 25 },
                    { title: "Aug", key: "aug", sortable: true, align: "start", width: 25 },
                    { title: "Sep", key: "sep", sortable: true, align: "start", width: 25 },
                    { title: "Oct", key: "oct", sortable: true, align: "start", width: 25 },
                    { title: "Nov", key: "nov", sortable: true, align: "start", width: 25 },
                    { title: "Dec", key: "dec", sortable: true, align: "start", width: 25 },
                    { title: "Jan", key: "jan", sortable: true, align: "start", width: 25 },
                    { title: "Feb", key: "feb", sortable: true, align: "start", width: 25 },
                    { title: "Mar", key: "mar", sortable: true, align: "start", width: 25 },
                    { title: "Apr", key: "apr", sortable: true, align: "start", width: 25 },
                    { title: "May", key: "may", sortable: true, align: "start", width: 25 },
                    { title: "Jun", key: "jun", sortable: true, align: "start", width: 25 },
                    { title: this.totalColumnTitle, key: "total", sortable: true, align: "start", width: 25 },
				] as IDataTableHeader[],
			}
		},
		computed: {
			reportHeaders(): IDataTableHeader[] {
				return [...this.headers, ...this.fiscalHeaders];
			},
			totalRow(): { [key: string]: any } {
				const row = {
					jul: this.reportData.map(x => x.jul).reduce((currentVal, newVal) => currentVal + newVal, 0),
					aug: this.reportData.map(x => x.aug).reduce((currentVal, newVal) => currentVal + newVal, 0),
					sep: this.reportData.map(x => x.sep).reduce((currentVal, newVal) => currentVal + newVal, 0),
					oct: this.reportData.map(x => x.oct).reduce((currentVal, newVal) => currentVal + newVal, 0),
					nov: this.reportData.map(x => x.nov).reduce((currentVal, newVal) => currentVal + newVal, 0),
					dec: this.reportData.map(x => x.dec).reduce((currentVal, newVal) => currentVal + newVal, 0),
					jan: this.reportData.map(x => x.jan).reduce((currentVal, newVal) => currentVal + newVal, 0),
					feb: this.reportData.map(x => x.feb).reduce((currentVal, newVal) => currentVal + newVal, 0),
					mar: this.reportData.map(x => x.mar).reduce((currentVal, newVal) => currentVal + newVal, 0),
					apr: this.reportData.map(x => x.apr).reduce((currentVal, newVal) => currentVal + newVal, 0),
					may: this.reportData.map(x => x.may).reduce((currentVal, newVal) => currentVal + newVal, 0),
					jun: this.reportData.map(x => x.jun).reduce((currentVal, newVal) => currentVal + newVal, 0),
					total: this.reportData.map(x => x.total).reduce((currentVal, newVal) => currentVal + newVal, 0),
				} as { [key: string]: any };

				if (this.headers.length > 0) {
					const firstColKey = this.headers[0].key;
					row[firstColKey] = "Total";
				}

				return row;
			},
			dataWithTotals(): IFiscalYearReport[] {
				return this.reportData.length == 0 ? this.reportData : [...this.reportData, this.totalRow as IFiscalYearReport];
			},
            reportPdfHeaders(): any[] {
                return this.reportHeaders.map(x => { return { header: x.title, dataKey: x.key } });
            },
            reportJsonHeaders(): any {
                var jsonObj = {} as any;
                this.reportHeaders.forEach(h => jsonObj[h.title] = h.key);
                return jsonObj;
            },
		},
	});
